import { createAsyncThunk } from "@reduxjs/toolkit"

import { IOneVerifyReportCoverageResultDataUnmapped } from "@common-shared/types/requestData/oneVerifyRequestData.types"

import { ToastrHelper } from "@front-shared/helpers/toastr.helper"

import { SupportService } from "../../services/support.service"
import type { IThunkActionWithPracticeData } from "../../types/general.types"
import {
    runtimeStartLoading,
    runtimeStopLoading,
} from "../slices/runtime.slice"

/**
 * Report coverage result
 */
export const supportReportCoverageResult = createAsyncThunk<
    void,
    IThunkActionWithPracticeData<IOneVerifyReportCoverageResultDataUnmapped>
>("supportReportCoverageResultPrefix", async (action, { dispatch }) => {
    dispatch(runtimeStartLoading("supportReportCoverageResultLoading"))

    try {
        const result = await SupportService.reportCoverageResult(
            action.payload,
            action.practice,
        )

        if (result) {
            action.onSuccess?.(result)

            ToastrHelper.success(
                "Thank you. Nirvana Team received your request and will process it soon",
            )
        } else {
            action.onError?.(result)
        }
    } catch (e) {
    } finally {
        dispatch(runtimeStopLoading("supportReportCoverageResultLoading"))

        action.onFinally?.()
    }
})
